<div class="dialog-header">
    <mat-toolbar id="dialog-titlebar" color="primary" mat-dialog-title> Lab Partner - Contact & Support </mat-toolbar>
  </div>
  <div mat-dialog-content class="dialog-content">
    <div class="title">Request Access: <a href="https://forms.office.com/r/QtjT3q2zDC">https://forms.office.com/r/QtjT3q2zDC</a></div>
    <div class="title">Request/Change Feature <a href="https://forms.office.com/r/4sWnu7ZXcd">https://forms.office.com/r/4sWnu7ZXcd</a></div>
    <div class="title">Report a Bug: <a href="https://forms.office.com/r/L6SDSP6PnB">https://forms.office.com/r/L6SDSP6PnB</a></div>
</div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" (click)="onClickClose()">Close</button>
  </div>
  